import { render, staticRenderFns } from "./RecruiterQaToast.vue?vue&type=template&id=2be8e745&scoped=true"
import script from "./RecruiterQaToast.vue?vue&type=script&lang=js"
export * from "./RecruiterQaToast.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaToast.vue?vue&type=style&index=0&id=2be8e745&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be8e745",
  null
  
)

export default component.exports